import { Timeline } from '@services/Timeline';

export class ApplicationTimeline {
    private static _timeline: Timeline;
    private static _timelineId: string;

    public static getTimeline(): Timeline {
        if (!ApplicationTimeline._timeline) {
            if (!ApplicationTimeline._timelineId) {
                // Fail loudly since this must be initialized in parent application before use
                throw new Error('Must provide a timelineId before using applicationTimeline');
            } else {
                ApplicationTimeline._timeline = new Timeline(ApplicationTimeline._timelineId);
            }
        }
        return ApplicationTimeline._timeline;
    }

    public static setTimelineId(timelineId: string) {
        ApplicationTimeline._timelineId = timelineId;
    }
}
